// Номера счётчиков Метрики по домену (TST-019): цели уходят в счётчик своего домена.
// Префикс «www.» снимается: www.msk → счётчик филиала, www. → основной.
const METRIKA_IDS = {
    'vector-trailer.ru': '34175205',
    'msk.vector-trailer.ru': '103965349'
};
const METRIKA_DEFAULT_ID = '34175205';
const getMetrikaID = (domain = window.location.hostname) => METRIKA_IDS[domain.replace(/^www\./, '')] || METRIKA_DEFAULT_ID;
// Цель Метрики в счётчик своего домена (TST-028)
const reachMetrikaGoal = (goalId) => {
    if (typeof window.ym === 'function') {
        window.ym(getMetrikaID(), 'reachGoal', goalId);
    }
};
export { getMetrikaID, reachMetrikaGoal };
